import HtmlElementBuilder from '../utils/HtmlElementBuilder';

export default function FooterDropDown() {

	const render = () => {
		const footerDropDownItems = Array.from(document.querySelectorAll<HTMLDivElement>('.c-footer-dropdown'));

    if (!footerDropDownItems.length) return;

    footerDropDownItems.forEach((dropdownItem: Element) => {
      const dropdown = new HtmlElementBuilder('button')
        .addClass('c-footer-dropdown__dropdown body-2 text-gray-1 medium')
        .addLabel(dropdownItem.querySelector('.c-footer-dropdown__title')?.textContent || 'Item')
        .prepend(
          new HtmlElementBuilder('i')
            .addClass('icon-chevron icon-chevron--right c-footer-dropdown__icon text-secondary')
            .build()
        )
        .onClick(() => (
          dropdownItem.classList.toggle('is-opened')
        ))
        .build();

        dropdownItem.prepend(dropdown);
    });
	}

	return { render };
}